import { Icon } from './Icon'
import { useDialog } from '../useDialog'

/**
 * The shortcut sheet, on `?`. Discoverability for the things that make the tool
 * fast — a shortcut nobody can find is a shortcut nobody uses.
 */
const GROUPS: { title: string; rows: [string[], string][] }[] = [
  {
    title: 'Moving around',
    rows: [
      [['⌘', 'K'], 'Go to a page, or run a command'],
      [['⌘', '\\'], 'Fold the sidebar, and unfold it'],
      [['?'], 'This sheet'],
      [['esc'], 'Close whatever is open'],
    ],
  },
  {
    title: 'The page tree',
    rows: [
      [['⌥', '↑'], 'Move a row up among its neighbours'],
      [['⌥', '↓'], 'Move it down'],
      [['⌥', '→'], 'Tuck it under the row above'],
      [['⌥', '←'], 'Bring it back out'],
      [['[', '['], 'Link to a page, while writing'],
    ],
  },
  {
    title: 'Writing',
    rows: [
      [['/'], 'Insert a block — callout, tabs, cards, table…'],
      [['⌘', 'S'], 'Save now (it also saves on its own)'],
      [['⌘', 'B'], 'Bold'],
      [['⌘', 'I'], 'Italic'],
      [['⌘', 'Z'], 'Undo'],
    ],
  },
  {
    title: 'Publishing',
    rows: [
      [['⌘', '⇧', 'R'], 'The changes waiting to be published'],
      [['⌘', '↵'], 'Commit, from the Advanced row of that drawer'],
    ],
  },
]

export function Shortcuts({ open, onClose }: { open: boolean; onClose: () => void }) {
  const panel = useDialog<HTMLDivElement>(open, onClose)
  if (!open) return null
  return (
    <div className="scrim" onMouseDown={onClose}>
      <div
        className="sheet"
        ref={panel}
        role="dialog"
        aria-modal="true"
        aria-label="Keyboard shortcuts"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <header className="sheet__head">
          <h2 className="sheet__title">
            <Icon name="keyboard" size={17} />
            Keyboard shortcuts
          </h2>
          <button className="btn btn--ghost btn--icon" onClick={onClose}>
            <Icon name="close" size={15} label="Close" />
          </button>
        </header>
        <div className="sheet__body">
          {GROUPS.map((g) => (
            <section key={g.title} className="sheet__group">
              <div className="label">{g.title}</div>
              {g.rows.map(([keys, what]) => (
                <div className="sheet__row" key={what}>
                  <span className="sheet__keys">
                    {keys.map((k) => (
                      <kbd key={k}>{k}</kbd>
                    ))}
                  </span>
                  <span className="sheet__what">{what}</span>
                </div>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  )
}
